export const getLogistName = (list: {[login: string]: string}, login: string) => {
	return list[login] ? list[login] : (login ? login : 'Логіст не знайден');
};